import { useEffect } from 'react';

import { type Collectible } from '@pkg/graphql/codegen/graphql';
import { useAccountsItems, useAppSelector } from '@pkg/hooks';

import { useNFTsFiltersStore } from '@app/store/zustand';

export function useProfileCollectibles() {
    const { showHiddenNfts, setFilteredCounts } = useNFTsFiltersStore();
    const pageOwnerId = useAppSelector((s) => s.yatPage.user_id);
    const { data, ...rest } = useAccountsItems({ pageOwnerId });
    const accounts = data?.pagesData;
    const collectibles = accounts?.flatMap((account) => account?.collectibles);

    const items = collectibles?.reduce(
        (acc, curr) => {
            if (curr?.hidden) {
                acc.hidden = [...acc.hidden, curr];
            } else {
                acc.visible = [...acc.visible, curr];
            }
            return acc;
        },
        { hidden: [] as Collectible[], visible: [] as Collectible[] },
    ) || { hidden: [] as Collectible[], visible: [] as Collectible[] };

    useEffect(() => {
        setFilteredCounts({ hiddenCount: items.hidden?.length, visibleCount: items.visible?.length });
    }, [items.hidden?.length, items.visible?.length, setFilteredCounts]);

    const filteredItems = showHiddenNfts ? items.hidden : items.visible;
    const nftEntries = showHiddenNfts === undefined ? collectibles : filteredItems;

    return { items: nftEntries, isLoadingAccounts: rest.isLoading, itemCount: collectibles?.length, ...rest };
}
